import { SagaIterator } from "redux-saga";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import {
  setAnswer,
  setAnswerLoading,
  setModerationList,
} from "../../repository/slice";
import { selectQuiz } from "../../repository/selector";

function* getAnswersWorker({ payload }: any): SagaIterator {
  const { id } = payload;
  const state = yield select(selectQuiz);

  try {
    yield put(setAnswerLoading([...state.answerLoading, id]));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      `/api/admin/quiz/get/attempts-for-moderation/${id}`
    );

    if (isError) {
      console.error(message);
    } else {
      yield put(setAnswer({ id, data }));
    }
  } catch (error) {
    console.error("getAnswersWorker: ", error);
  } finally {
    const updatedLoading = state.answerLoading.filter(
      (item: string) => item !== id
    );
    yield put(setAnswerLoading(updatedLoading));
  }
}

export function* getAnswersWatcher() {
  yield takeEvery("@saga/GET_ANSWERS", getAnswersWorker);
}
